module.exports = "/lucky-balls/img/jackpot/017.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/lucky-balls/img/jackpot/017.png
// module id = 1117
// module chunks = 0